import { render, staticRenderFns } from "./QuestionClue.vue?vue&type=template&id=796035da&"
import script from "./QuestionClue.vue?vue&type=script&lang=ts&"
export * from "./QuestionClue.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionClue.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports